export const TOKEN_TYPES = {
    UAM: 'UAM',
} as const;

export type TokenType = (typeof TOKEN_TYPES)[keyof typeof TOKEN_TYPES];
